/**
 * 合并 C 端 marketConfig：首页 @/models + 交易页 store/market.symbols。
 * 数据来源均为 GET /sapi/v4/market/public/symbol。
 */
export function buildMarketConfigMap(modelsMarketConfig, tradeSymbols) {
  const map = { ...(modelsMarketConfig || {}) };
  if (Array.isArray(tradeSymbols)) {
    tradeSymbols.forEach((obj) => {
      if (obj?.symbol) {
        map[obj.symbol] = { ...map[obj.symbol], ...obj };
      }
    });
  }
  return map;
}

/**
 * 是否展示 AI 分析入口。
 * 严格 true 为开启，其余（false / undefined / 老接口无字段）均视为关闭。
 */
export function isAiselectEligibleSymbol(marketName, marketConfig) {
  const symbol = String(marketName || "").trim().toLowerCase();
  if (!symbol) return false;
  const cfg = marketConfig?.[symbol];
  return cfg?.aiAnalysisEnabled === true;
}
